export default () => {
  const helperEl = document.querySelector('.curency-redirect-helper');
  if (!helperEl) { return false; }

  const {
    redirectSettings,
    shopCurrency,
    activeCurrency,
    geoPages,
  } = helperEl.dataset;

  const initCountryDropdownEvent = () => {
    const form = document.querySelector('.localization-form');
    const buttonEl = document.querySelector('.current-country');
    const dropdownEl = document.querySelector('.countries');
    const dropdownListEls = document.querySelectorAll('.countries .country');
    const countrySelect = form.querySelector('#country_code');
    const popupEl = document.querySelector('.country-popup');
    const popupCloseEls = document.querySelectorAll('.js-popup__close');
    buttonEl.addEventListener('click', () => {
      if (window.innerWidth < 993) {
        popupEl.classList.toggle('active');
      } else {
        dropdownEl.classList.toggle('active');
      }
    });

    popupCloseEls.forEach((closeEl) => {
      closeEl.addEventListener('click', () => {
        popupEl.classList.remove('active');
      });
    });

    dropdownListEls.forEach((el) => {
      el.addEventListener('click', () => {
        const value = el.getAttribute('data-value');
        countrySelect.value = value;
        form.submit();
      });
    });
  };

  const initCountryPopupEvent = () => {
    const popupEl = document.querySelector('.country-direct__popup');
    const popupCloseEls = document.querySelectorAll('.js-direct__popup-close');

    popupCloseEls.forEach((closeEl) => {
      closeEl.addEventListener('click', () => {
        popupEl.classList.remove('active');
        localStorage.setItem('popup-direct', 1);
      });
    });
  };

  const sectionSettings = JSON.parse(redirectSettings).map((item) => ({
    currency: String(item.title).toUpperCase(),
    countries: String(item.countries).toUpperCase().replaceAll(' ', '').split(','),
  }));
  if (!sectionSettings && sectionSettings.length <= 0) { return false; }

  const switchToCurrency = (targetCurrency) => {
    if (!targetCurrency || activeCurrency == targetCurrency || Shopify.designMode) return false;

    const popupEl = document.querySelector('.country-direct__popup');
    if (!localStorage.getItem('popup-direct')) popupEl.classList.add('active');
  };

  const init = (country) => {
    initCountryDropdownEvent();
    initCountryPopupEvent();

    const { countries, urls } = JSON.parse(geoPages);

    // eslint-disable-next-line max-len
    const redirectToIndex = countries && urls && !countries.includes(country) && urls.includes(window.location.pathname);
    if (redirectToIndex) {
      window.location.replace('/');
    } else {
      const targetBlock = sectionSettings.find((item) => item.countries.includes(country));
      if (targetBlock) {
        switchToCurrency(targetBlock.currency);
      } else {
        switchToCurrency(shopCurrency);
      }
    }
  };

  let detectedCountry = window.ipwhoisData ? window.ipwhoisData.country_code : '';
  window.dataRegion = detectedCountry;
  if (!detectedCountry) {
    window.addEventListener('ipwhois:success', (evt) => {
      detectedCountry = evt.detail ? evt.detail.country_code : null;
      if (detectedCountry) {
        window.dataRegion = detectedCountry;
        init(detectedCountry);
      } else {
        console.error('Detected country invalid');
      }
    });
  } else {
    init(detectedCountry);
  }
};
